module.exports = __webpack_public_path__ + "static/simplr-logo-73e3879aafcd7e1e02f31f5b8cf2d7a9.png";